import React from 'react';
import PropTypes from 'prop-types';

const EmptySection = ({ label }) => (
  <div
    id="no_results_historial"
    className="exclamation panel panel-light2 padding-2 full-width text-center"
  >
    <i className="fa fa-info-circle texto-blanco fa-3x text-center" />
    <p className="padding-top-2 text-center">{label.historyEmpty}</p>
  </div>
);

EmptySection.propTypes = {
  label: PropTypes.object,
};

export default EmptySection;
